import { Application } from './Application'
import { PaginationOption } from './PaginationOption'

export class Pagination {

    public Id: string;
    public Option: PaginationOption;
    public OnPageChanged: () => void;
    private paginator3000: Paginator;
    private $pagesCount: JQuery;

    constructor(private Application: Application, private $Root: JQuery) {

        //Get options from attributes which was set via partial views Pagination
        this.Option = new PaginationOption();
        this.Option.Url = $Root.data("url");
        this.Option.AjaxUrl = $Root.data("ajaxurl");
        this.Id = $Root.attr("id");
        this.Option.Total = $Root.data("total") || 0;
        this.Option.Take = parseInt($Root.data("take")) || 0;
        this.Option.CurrentPage = parseInt($Root.data("currentpage")) || 1;
        this.Option.Delay = $Root.data("delay");

        //check the pagination works on ajax mode.
        var containerId = $Root.data("container");
        if (containerId) {
            this.Option.$DataContainer = $('#' + containerId);
            if (this.Option.$DataContainer.length > 0 && this.Option.AjaxUrl) {
                this.$Root.on("click", "a", (ev) => this.OnClick(ev));
            }
        }
        this.$pagesCount = $('#' + this.Id + "-pages");
        //(Re)initialization of paginator30000
        if (!this.Option.Delay) {
            this.Reset();
        }

        this.OnPageChanged = () => { };
    }

    public Reset() {
        if (this.Option.Take > 0) {
            this.Option.TotalPages = Math.ceil(this.Option.Total / this.Option.Take);
        } else {
            this.Option.TotalPages = 1;
        }
        var url = this.Option.Url;

        if (this.Option.Url && this.Option.Url.indexOf("?") < 0) {
            url = url + "?page={page}";
        } else {
            url = url + "&page={page}";
        }

        if (this.Option.TotalPages > 1) {
            this.$pagesCount.html(this.Option.TotalPages + " pages");
            this.$Root.show();
            this.$pagesCount.show();
            this.paginator3000 = new Paginator(this.Id, this.Option.TotalPages, 10, this.Option.CurrentPage, url);
        } else {
            this.$Root.hide();
            this.$pagesCount.hide();
        }
    }

    public IsRendered(): boolean {
        return this.$Root.find("table").length > 0;
    }

    public SetPage(pageId: number, loadData: boolean) {
        this.Option.CurrentPage = pageId;

        if (this.Option.TotalPages > 1) {
            this.paginator3000.inputData.pageCurrent = pageId;
            this.paginator3000.scrollToPageCurrent();
        }

        if (loadData) {
            this.LoadPageData(pageId);
        }
    }

    private LoadPageData(pageId: number) {
        var url;

        if (this.Option.AjaxUrl.indexOf("?") < 0) {
            url = this.Option.AjaxUrl + "?page=" + pageId;
        } else {
            url = this.Option.AjaxUrl + "&page=" + pageId;
        }

        this.Option.$DataContainer.addClass("u-loading");

        $("html, body").animate({ scrollTop: this.Option.$DataContainer.offset().top - $("#header").height() - 20 });

        $.ajax(
            {
                url: url,
                dataType: 'html'
            }).done(data => {
                if (data != null) {
                    this.Option.$DataContainer.html(data);
                    this.OnPageChanged();
                }
                this.Option.$DataContainer.removeClass("u-loading");
            });
    }

    private OnClick(ev: JQuery.ClickEvent) {
        ev.preventDefault();
        var $target = $(ev.target);
        var pageId = parseInt($target.html());
        this.SetPage(pageId, true);
    }
}
